<app-dialog class="confirm-modal">
  <app-dialog-header>
    {{ data.title | translate }}
  </app-dialog-header>

  <app-dialog-content
    class="confirm-modal__text"
    [class.confirm-modal__text_error]="data.textType === 'danger'"
    [innerHTML]="(data && data.text) ?? '' | translate"
  />

  <app-dialog-footer [justifyContent]="data.buttonsJustify ?? 'space-between'">
    @if (data.showCancelButton ?? true) {
      <button
        app-button
        variant="outlined"
        size="large"
        (click)="closeModal()"
      >
        @if (data && data.cancelLabel) {
          {{ data.cancelLabel | translate }}
        } @else {
          {{ 'shared.components.confirm-modal.buttons.cancel.label' | translate }}
        }
      </button>
    }

    <div class="apply_btns">
      @if (data.applyLabel2) {
        <button
          app-button
          variant="outlined"
          size="large"
          (click)="apply('apply2')"
        >
          {{ data.applyLabel2 | translate }}
        </button>
      }

      <button
        app-button
        size="large"
        [variant]="data.applyButtonVariant ?? 'primary'"
        (click)="apply()"
      >
        @if (data && data.applyLabel) {
          {{ data.applyLabel | translate }}
        } @else {
          {{ 'shared.components.confirm-modal.buttons.confirm.label' | translate }}
        }
      </button>
    </div>
  </app-dialog-footer>
</app-dialog>
